module.exports = __webpack_public_path__ + "static/media/settings.d071eff6.svg";